import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Card from '../CardWhite/Card';

import './styles/offers.scss';
import {setActiveIndex} from "../../actions/carousel";
import ClubsMap from "../ClubsMap";
import axios from "axios";
import {formatPhone} from "../../utils/utils";
import Cookies from "js-cookie"
import {resetStep, setPromocode} from "../../actions/card";
import TestdrivePromo from "../TestdrivePromo";
import QABlock from "../QABlock";
import TaxDeduction from "../TaxDeduction";

class Offers extends Component {

    state = {
        clubs: null,
        promocodeTooltipActive: false,
        expandedIncludes: false,
        hideDiscountWidget: true,
        discountTooltipActive: false,
        qa: null,
    }

    componentDidMount() {
        const self = this
        axios
            .get(process.env.REACT_APP_API_SITE + '/clubs')
            .then((response) => {
                response.data.data.data.forEach((club) => {
                    club.formatted_phone = formatPhone(club.phone);
                    club.page_link = `https://fitron.club/clubs/${club.slug}/`;
                });
                self.setState({clubs: response.data.data.data});
            })
            .catch(function (error) {
                self.setState({clubs: null});
            });

        axios
            .get(`${process.env.REACT_APP_API_SITE}/question-categories/club-cards`)
            .then((response) => {
                self.setState({qa: response.data.data.questions});
            })
            .catch(function (error) {
                self.setState({qa: null});
            });

        this.props.resetStep(1)

        localStorage.removeItem('cardId')
        localStorage.removeItem('cardPrice')
        localStorage.removeItem('cardTitle')
        localStorage.removeItem('club')
        localStorage.removeItem('email')
        localStorage.removeItem('name')
        localStorage.removeItem('orderId')
        localStorage.removeItem('paymentLink')
        localStorage.removeItem('phone')
        localStorage.removeItem('hasActiveContract')
        localStorage.removeItem('agreements')

        if (!Cookies.get('hideDiscountWidget')) {
            this.setState({ hideDiscountWidget: false });
        }

        //Отображение триггера gamelead при возвращении с другого шага
        const gameleadCard = this.props?.mainData?.cards?.find(card => card.gamelead);
        if (
          !Cookies.get('hideGameLead')
          && gameleadCard
          && gameleadCard.gamelead_show_trigger
          && gameleadCard.gamelead_trigger_image
          && document.getElementById('game-lead-script')
          && !document.getElementById('game-lead-button')
        ) {
            const gameLeadButton = document.createElement('div'),
              icon = document.createElement('img')

            icon.src = gameleadCard.gamelead_trigger_image

            gameLeadButton.id = 'game-lead-button'
            gameLeadButton.className = 'icon_gamelead ' + (window.location.hash == '#testdrive' ? 'icon_location_4' : 'icon_location_3') //+ ' icon_animation_4'
            gameLeadButton.style = 'width: 130px; height: 130px'
            // eslint-disable-next-line no-undef
            gameLeadButton.onclick = function () {GameLead()};
            gameLeadButton.appendChild(icon)

            const span = document.createElement('span')
            span.style = 'display: block; position: absolute; top: 2px; right: 13px; width: 20px; height: 20px;'
            span.onclick = function (event) {
                event.preventDefault()
                event.stopPropagation()
                //document.cookie = "hideGameLead=1; max-age=43200";
                document.getElementById('game-lead-button').remove()
            };
            gameLeadButton.appendChild(span)

            document.getElementById('offers-cont').appendChild(gameLeadButton);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const gameleadCard = this.props?.mainData?.cards?.find(card => card.gamelead);

        if (!Cookies.get('hideGameLead') && gameleadCard) {
            if (!document.getElementById('game-lead-script')) {
                const script = document.createElement('script');

                script.id = "game-lead-script"
                script.src = "https://game-lead.ru/set/6adb08507fc10ad331b405b05f5a6e25";
                script.async = true;
                script.onload = function () {
                    if (gameleadCard.gamelead_show_trigger && gameleadCard.gamelead_trigger_image) {
                        const gameLeadButton = document.createElement('div'),
                          icon = document.createElement('img')

                        icon.src = gameleadCard.gamelead_trigger_image

                        gameLeadButton.id = 'game-lead-button'
                        gameLeadButton.className = 'icon_gamelead ' + (window.location.hash == '#testdrive' ? 'icon_location_4' : 'icon_location_3')// + ' icon_animation_4'
                        gameLeadButton.style = 'width: 130px; height: 130px; position: fixed;'
                        // eslint-disable-next-line no-undef
                        gameLeadButton.onclick = function () {GameLead()};
                        gameLeadButton.appendChild(icon)

                        const span = document.createElement('span')
                        span.style = 'display: block; position: absolute; top: 2px; right: 13px; width: 20px; height: 20px;'
                        span.onclick = function (event) {
                            event.preventDefault()
                            event.stopPropagation()
                            //document.cookie = "hideGameLead=1; max-age=43200";
                            document.getElementById('game-lead-button').remove()
                        };
                        gameLeadButton.appendChild(span)

                        document.getElementById('offers-cont').appendChild(gameLeadButton);
                    }

                    if (window.location.hash !== '#testdrive') {
                        var show_time = 7,
                          value_show = 3596400,
                          flag_show = true,
                          showidget = Cookies.get("showidget");

                        if (!isNaN(showidget) && parseInt(showidget) && Math.floor(new Date().getTime() / 1000) - parseInt(showidget) < value_show) {
                            flag_show = false;
                        }

                        if (show_time && flag_show) {
                            function showGameLeadPopup() {
                                setTimeout(function () {
                                    if (!document.getElementById('fancyboxw-container-1')) {
                                        showGameLeadPopup()
                                    } else {
                                        // eslint-disable-next-line no-undef
                                        GameLead();
                                    }
                                }, show_time * 1000);
                            }

                            showGameLeadPopup()
                        }
                    }
                }

                document.body.appendChild(script);
            }
        }
    }

    copyPromocode(code, discount) {
        navigator.clipboard.writeText(code)
        this.props.setPromocode({
            'code': code,
            'discount': discount
        })

        var self = this
        this.setState({'promocodeTooltipActive': true})

        setTimeout(function() {
            self.setState({'promocodeTooltipActive': false})
        }, 2000);
    }

    expandIncludes(val) {
        this.setState({'expandedIncludes': val})
    }

    /*
    clickDiscountWidget() {
        var self = this
        this.setState({'discountTooltipActive': true})

        setTimeout(function() {
            self.setState({'discountTooltipActive': false})

            Cookies.set('hideDiscountWidget', true, { expires: 14 });

            self.setState({
                hideDiscountWidget: true
            });
        }, 2000);
    }
     */

    closeDiscountWidget(event) {
        event.preventDefault()
        event.stopPropagation()

        Cookies.set('hideDiscountWidget', true, { expires: 1 });

        this.setState({
            hideDiscountWidget: true
        });
    }

    render() {

        const {
            mainData,
            history
        } = this.props;

        const options = {
            wheelSpeed: 1,
            maxScrollbarLength: 132
        }

        return (
          <div id="offers-cont">
              <div>
                  <div className="container">
                      <div className="offers" id="offers">
                          <div className="offers__header">

                          </div>

                          <div
                            className={`offers__cards ` + (mainData && mainData.cards && mainData.cards.length < 4 ? 'offers__cards_three' : '')}>
                              {
                                  mainData && mainData.cards
                                    ? mainData.cards.map((el, ind) => {
                                        return (
                                          <div
                                            className={'offers__cards__item ' + (el.title == 'SALE' ? 'new-year-sale' : '') + (
                                              (el.test_drive && window.location.hash === '#testdrive')
                                              || (el.title === 'Новогодний' && window.location.hash === '#newyear')
                                              || (el.title === 'Фестивальный' && window.location.hash === '#fest')
                                              || (el.title === 'Индивидуальный' && window.location.hash === '#individual')
                                              || (el.title === 'Семейный' && window.location.hash === '#family')
                                              || (el.title === 'Студенческий' && window.location.hash === '#student')
                                              || (el.title === 'Комфортный' && window.location.hash === '#comfort')
                                              || (el.title === 'Сезонный' && window.location.hash === '#season')
                                              || (el.title === 'Выгодный' && window.location.hash === '#vygoda')
                                              || (el.title === 'Подписка' && window.location.hash === '#subscription')
                                              || (el.slug === window.location.hash.substring(1)) ? ' order-1' : ''
                                            ) + (el.gift ? ' background-frame-blue' : '')}
                                            key={ind}>
                                              <div className="offers__cards__item__white">
                                                  <Card
                                                    ind={ind}
                                                    card={el}
                                                    title={el.title}
                                                    header_class={el.header_class}
                                                    subscription={el.subscription}
                                                    comfort={el.comfort}
                                                    test_drive={el.test_drive}
                                                    base_months={el.base_months}
                                                    cost_month_base={el.cost_month_base}
                                                    base_freezing_months={el.base_freezing_months}
                                                    subscription_cost_first_month={el.subscription_cost_first_month}
                                                    cost_fixed={el.cost_fixed}
                                                    visit_count_fixed={el.visit_count_fixed}
                                                    tinkoff_credit_available={el.tinkoff_credit_available}
                                                    tinkoff_loan_available={el.tinkoff_loan_available}
                                                    dolyame_available={el.dolyame_available}
                                                    prolongation_discount={el.prolongation_discount}
                                                    clubs={el.clubs}
                                                    includes={el.includes}
                                                    withExpiresBlock={mainData.cards.some(card => card.expires)}
                                                    expires={el.expires}
                                                    millenium_add_price={el.millenium_add_price}
                                                    millenium_add_first_month_price={el.millenium_add_first_month_price}
                                                    millenium_privileges={el.millenium_privileges}
                                                    millenium_add_price_freezing={el.millenium_add_price_freezing}
                                                    millenium_add_fixed_price={el.millenium_add_fixed_price}
                                                    expandedIncludes={this.state.expandedIncludes}
                                                    expandIncludes={this.expandIncludes.bind(this)}
                                                    gift={el.gift}
                                                    gift_title={el.gift_title}
                                                    gift_subtitle={el.gift_subtitle}
                                                    unconditional_discount={el.unconditional_discount}
                                                    installments={el.installments}
                                                    history={history}
                                                    widgets={el.widgets}
                                                    apply_widget_discount={el.apply_widget_discount}
                                                    widget_discount_text={el.widget_discount_text}
                                                  />
                                              </div>
                                          </div>
                                        )
                                    })
                                    : null
                              }
                          </div>

                          {
                              !mainData || !mainData.cards
                                ? <div className="offers__loading">
                                    <img src={require('../../static/images/loading.gif')} alt=""/>
                                </div>
                                : null
                          }
                      </div>
                  </div>
              </div>

              <TaxDeduction />

              {this.state.clubs ? <ClubsMap clubs={this.state.clubs} id={3}/> : ''}

              <TestdrivePromo />

              {this.state.qa && this.state.qa.length ? <QABlock questions={this.state.qa}/> : null}

              {/*
                mainData && mainData.cards && mainData.cards.findIndex(card => card.slug === 'cosmos') > -1 && !this.state.hideDiscountWidget ?
                    <div className="offers__promocode-widget" onClick={() => {this.copyPromocode('COSMOS', 11)}}>
                        <img src={require('../../static/images/promocode/cosmos-11-widget.svg').default} alt=""/>
                        <span onClick={this.closeDiscountWidget.bind(this)}></span>
                        <div className={'copy-tooltip ' + (this.state.promocodeTooltipActive ? 'active' : '')}>Промокод скопирован</div>
                    </div>
                    : ''
              */}
              {/*
                  !this.state.hideDiscountWidget ?
                    <div className="offers__discount-widget" onClick={() => {
                        this.clickDiscountWidget()
                    }}>
                        <img src={require('../../static/images/discount/5-percent.svg').default} alt=""/>
                        <span onClick={this.closeDiscountWidget.bind(this)}></span>
                        <div className={'copy-tooltip ' + (this.state.discountTooltipActive ? 'active' : '')}>
                            Скидка активирована
                        </div>
                    </div>
                    : ''
              */}
          </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        mainData: state.card.mainData,
        timeVisitsData: state.card.timeVisitsData,
        activeIndex: state.carousel.activeIndex
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({
    setActiveIndex,
    resetStep,
    setPromocode
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
